<div class="row gx-2 align-items-center">
  @for (filter of filters; track filter) {
    <div class="col-auto">
      <button
        type="button"
        class="filter-tab btn btn-light border"
        (click)="onRemove(filter)"
        >
        {{ filter.label | translate }} <i class="fas fa-times fa-fw"></i>
      </button>
    </div>
  }
</div>
